"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
//
// styles
//
const StyledIcon_1 = require("../StyledIcon");
const StyledMenu_1 = require("./StyledMenu");
const StyledOption_1 = require("./StyledOption");
const Dropdown = (props) => {
    const [optionsVisible, setOptionsVisible] = react_1.default.useState(false);
    const wrapperRef = (0, react_1.useRef)(null);
    function detectClick(ref) {
        (0, react_1.useEffect)(() => {
            function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                    setOptionsVisible(false);
                }
            }
            document.addEventListener('mousedown', handleClickOutside);
            return () => {
                document.removeEventListener('mousedown', handleClickOutside);
            };
        }, [ref]);
    }
    detectClick(wrapperRef);
    function handleToggleDropdown() {
        setOptionsVisible((current) => !current);
    }
    return (react_1.default.createElement("div", { className: 'dropdown', ref: wrapperRef },
        react_1.default.createElement("a", { "aria-expanded": 'false', "aria-haspopup": 'true', "data-toggle": 'dropdown', href: '#', onClick: handleToggleDropdown, role: 'button' },
            react_1.default.createElement(StyledIcon_1.StyledIcon, { className: 'fe fe-more-horizontal' })),
        props.active ? (react_1.default.createElement(StyledMenu_1.StyledMenu, { className: 'dropdown-menu dropdown-menu-car', 
            // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
            large: true, show: optionsVisible },
            react_1.default.createElement(StyledOption_1.StyledOption, { className: 'dropdown-item', 
                // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
                href: '#!', onClick: props.onEdit }, "Edit"),
            react_1.default.createElement(StyledOption_1.StyledOption, { className: 'dropdown-item', 
                // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
                href: '#!', onClick: props.onArchive }, "Archive"),
            react_1.default.createElement(StyledOption_1.StyledOption, { className: 'dropdown-item', 
                // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
                href: '#!', onClick: props.onDelete }, "Delete"))) : (react_1.default.createElement(StyledMenu_1.StyledMenu, { className: 'dropdown-menu dropdown-menu-car', 
            // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
            show: optionsVisible },
            react_1.default.createElement(StyledOption_1.StyledOption, { className: 'dropdown-item', 
                // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
                href: '#!', onClick: props.onRestore }, "Restore"),
            react_1.default.createElement(StyledOption_1.StyledOption, { className: 'dropdown-item', 
                // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
                href: '#!', onClick: props.onDelete }, "Delete")))));
};
Dropdown.propTypes = {
    active: prop_types_1.default.bool,
    onArchive: prop_types_1.default.func,
    onDelete: prop_types_1.default.func,
    onEdit: prop_types_1.default.func,
    onRestore: prop_types_1.default.func
};
exports.default = Dropdown;
